import { Routes } from '@angular/router';
import { permisoGuard } from '../core/auth/permiso.guard';
import { Permiso } from '../core/auth/permisos';

/** Sección a la que pertenecen estas pantallas (encabezado de la bandeja). */
const SECCION = 'Biología Molecular (BIO-MOL)';

/**
 * Sección de Biología Molecular (BIO-MOL): las tres enfermedades aviares que
 * además se corren por PCR en tiempo real. Cada una reusa la hoja y la página
 * de Virología —el formato de la enfermedad ya reporta la RT-PCR junto a las
 * otras técnicas—; lo que cambia es la pantalla, que llega por el `data` de la
 * ruta y decide bandeja, endpoint y permiso.
 */
export const biologiaMolecularRoutes: Routes = [
  {
    path: 'biologia-molecular/influenza-aviar',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Influenza Aviar (PCR)',
    data: {
      pantalla: 'INFLUENZA_AVIAR_PCR',
      breadcrumb: SECCION,
      titulo: 'Influenza Aviar (PCR en tiempo real)',
      permiso: Permiso.INFLUENZA_AVIAR_PCR_VER,
    },
  },
  {
    path: 'biologia-molecular/influenza-aviar/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'INFLUENZA_AVIAR_PCR',
      permiso: [Permiso.INFLUENZA_AVIAR_PCR_RESULTADOS, Permiso.INFLUENZA_AVIAR_PCR_VER],
    },
    loadComponent: () =>
      import('../virologia/pages/influenza-aviar-resultados/influenza-aviar-resultados.page').then(
        (m) => m.InfluenzaAviarResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultados — Influenza Aviar (PCR)',
  },
  {
    path: 'biologia-molecular/laringotraqueitis',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Laringotraqueítis Aviar (PCR)',
    data: {
      pantalla: 'LARINGOTRAQUEITIS_PCR',
      breadcrumb: SECCION,
      titulo: 'Laringotraqueítis Aviar (PCR en tiempo real)',
      permiso: Permiso.LARINGOTRAQUEITIS_PCR_VER,
    },
  },
  {
    path: 'biologia-molecular/laringotraqueitis/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'LARINGOTRAQUEITIS_PCR',
      permiso: [Permiso.LARINGOTRAQUEITIS_PCR_RESULTADOS, Permiso.LARINGOTRAQUEITIS_PCR_VER],
    },
    loadComponent: () =>
      import('../virologia/pages/laringotraqueitis-resultados/laringotraqueitis-resultados.page').then(
        (m) => m.LaringotraqueitisResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultados — Laringotraqueítis Aviar (PCR)',
  },
  {
    path: 'biologia-molecular/newcastle',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Enfermedad de Newcastle (PCR)',
    data: {
      pantalla: 'NEWCASTLE_PCR',
      breadcrumb: SECCION,
      titulo: 'Enfermedad de Newcastle (PCR en tiempo real)',
      permiso: Permiso.NEWCASTLE_PCR_VER,
    },
  },
  {
    path: 'biologia-molecular/newcastle/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'NEWCASTLE_PCR',
      permiso: [Permiso.NEWCASTLE_PCR_RESULTADOS, Permiso.NEWCASTLE_PCR_VER],
    },
    loadComponent: () =>
      import('../virologia/pages/newcastle-resultados/newcastle-resultados.page').then(
        (m) => m.NewcastleResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultados — Enfermedad de Newcastle (PCR)',
  },
];
